import React from 'react';
import { Link } from 'react-router-dom'


const Invoices = () => {

    const list = [
        {
          id: '1001',
          name: 'Himanshu Rawat',
          contact: '9131251818',
          numberOfPerson: '2',
          paidAmount: '$ 450',
          tableNo: '18',
          source: 'Website',
          bookingDate: '25 June 2021',
          bookingTime : '5:00 PM',
          createdOn: '22 May 2021',
          rating : '4.1',
          comment : 'Very Tasty food !',
          status: 'Active',
        }
      ]

    return (
        <div className="w-full p-6  ">

        <p className="min-w-max font-semibold text-gray-700">Invoices</p>

        <div className="mt-3 flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-3 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        ID
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Type
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        $ Value
                                    </th>
                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Start Date
                                    </th>

                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        End Date
                                    </th>

                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Payment Methods
                                    </th>

                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Remark
                                    </th>

                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Created By
                                    </th>



                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Created On
                                    </th>


                                    <th
                                        scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Receipt
                                    </th>
                                </tr>
                            </thead>

                            <tbody className="bg-white divide-y divide-gray-200">

                                {list && list.map((item, index) => {

                                    return (
                                        <tr key={index}>
                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-blue-400">
                                                Id : {item.id}
                                            </td>

                                            <Link to={`/restaurants/${item.id}`}><td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                                {item.name}
                                            </td></Link>

                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.contact}
                                            </td>

                                            <td className="px-3 py-4 whitespace-nowrap text-sm font-bold text-red-500 ">
                                                {item.numberOfPerson}
                                            </td>

                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.paidAmount}
                                            </td>

                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.tableNo}
                                            </td>


                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.source}
                                            </td>

                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.bookingDate}
                                            </td>



                                            <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {item.createdOn}
                                            </td>




                                            <td>
                                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                                    Download
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                })}




                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

</div>
    );
}

export default Invoices;
